import React, { useEffect, useState } from 'react';
import InventoryList from './InventoryList';
import ItemLocationList from '../item-location/ItemLocationList';
import HoldInventoryList from '../hold-inventory/HoldInventoryList';
import LotAndItemList from '../lot-and-item/LotAndItemList';
import { getInventorySection, subscribeInventorySection, clearItemLocationFocus, clearHoldInventoryFocus } from '../item-location/itemLocationFocus';

const TABS = [
  { id: 'inventory', label: 'Item Summary' },
  { id: 'itemLocation', label: 'Location Summary' },
  { id: 'hold', label: 'Hold Summary' },
  { id: 'lot', label: 'Lot Summary' },
];

const Inventory = () => {
  const [activeTab, setActiveTab] = useState(() => getInventorySection() || 'inventory');

  useEffect(() => subscribeInventorySection((section) => {
    if (section) setActiveTab(section);
  }), []);

  const activeLabel = TABS.find((tab) => tab.id === activeTab)?.label || 'Item Summary';

  return (
    <>
      <div className="card shadow-lg main-card" style={{ position: 'relative' }}>
       <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">{activeLabel}</h4>
      </div>
      <div className="card-body">
      <ul className="inventory-module-tabs" role="tablist">
        {TABS.map((tab) => (
          <li key={tab.id} role="presentation">
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={activeTab === tab.id ? 'active' : ''}
              onClick={() => {
                if (activeTab === 'itemLocation' && tab.id !== 'itemLocation') {
                  clearItemLocationFocus();
                }
                if (activeTab === 'hold' && tab.id !== 'hold') {
                  clearHoldInventoryFocus();
                }
                setActiveTab(tab.id);
              }}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
      {activeTab === 'inventory' && <InventoryList />}
      {activeTab === 'itemLocation' && <ItemLocationList />}
      {activeTab === 'hold' && <HoldInventoryList />}
      {activeTab === 'lot' && <LotAndItemList />}
        </div>
        </div>
    </>
  
  );
};

export default Inventory;
